import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import React from 'react';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import PropTypes from 'prop-types';
import LoaderPortal from './LoaderPortal';
import { FadeInAnimation, FadeOutAnimation, LoadingAnimation } from './LoaderAnimations';
import FocusTrap from 'focus-trap-react';
import { withVDSManager } from '@vds-core/utilities';
import { ColorTokens } from '@vds-tokens/color';
export var propTypes = {
  /**
   * Loader will be active if 'active' prop is passed.
   */
  active: PropTypes.bool,

  /**
   * Loader will be contained in its container by default.
   */
  fullscreen: PropTypes.bool,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string,

  /**
   * @ignore
   */
  disableFocusLock: PropTypes.bool,

  /**
   * @ignore
   */
  inverted: PropTypes.bool
};
export var defaultProps = {
  active: false,
  fullscreen: false,
  disableFocusLock: false,
  inverted: false
};
var StyledOverlay = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledOverlay",
  componentId: "VDS__sc-27g4au-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 99999;\n  position: ", ";\n  display: ", ";\n  animation: ", "\n    0.15s linear;\n  opacity: 0.8;\n"])), function (_ref) {
  var inverted = _ref.inverted;
  return inverted ? ColorTokens.background.primary.dark.value : ColorTokens.background.primary.light.value;
}, function (props) {
  return props.fullscreen ? 'fixed' : 'absolute';
}, function (props) {
  return props.active ? 'block' : 'none';
}, function (props) {
  return props.active ? FadeInAnimation : FadeOutAnimation;
});
var StyledLoader = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledLoader",
  componentId: "VDS__sc-27g4au-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  outline: none;\n  display: ", ";\n  animation: ", "\n    0.15s linear;\n  content: '';\n  position: ", ";\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  width: ", ";\n  height: ", ";\n  display: block;\n  z-index: 3;\n  border: ", " solid\n    ", ";\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: ", " 0.5s infinite linear;\n"])), function (props) {
  return props.active ? 'block' : 'none';
}, function (props) {
  return props.active ? FadeInAnimation : FadeOutAnimation;
}, function (props) {
  return props.fullscreen ? 'fixed' : 'absolute';
}, calculateRem(40), calculateRem(40), calculateRem(4), function (_ref2) {
  var inverted = _ref2.inverted;
  return inverted ? ColorTokens.elements.primary.ondark.value : ColorTokens.elements.primary.onlight.value;
}, LoadingAnimation);

var Loader = function Loader(_ref3) {
  var active = _ref3.active,
      fullscreen = _ref3.fullscreen,
      id = _ref3.id,
      disableFocusLock = _ref3.disableFocusLock,
      inverted = _ref3.inverted;

  if (active) {
    if (fullscreen) {
      return /*#__PURE__*/React.createElement(LoaderPortal, {
        "aria-label": "loader container",
        id: id
      }, /*#__PURE__*/React.createElement(FocusTrap, {
        focusTrapOptions: {
          escapeDeactivates: false
        },
        active: !disableFocusLock
      }, /*#__PURE__*/React.createElement(StyledOverlay, {
        active: active,
        "aria-label": "loader overlay",
        fullscreen: fullscreen,
        inverted: inverted
      }, /*#__PURE__*/React.createElement(StyledLoader, {
        tabIndex: 0,
        active: active,
        "aria-label": "loader animation",
        inverted: inverted
      }))));
    }

    return /*#__PURE__*/React.createElement(StyledOverlay, {
      active: active,
      "aria-label": "loader overlay",
      inverted: inverted
    }, /*#__PURE__*/React.createElement(StyledLoader, {
      tabIndex: 0,
      active: active,
      "aria-label": "loader animation",
      inverted: inverted
    }));
  }

  return null;
};

Loader.propTypes = propTypes;
Loader.defaultProps = defaultProps;
export default withVDSManager(Loader);